export const GET_PROGRAMMES = 'programme.GET_PROGRAMMES'
export const SET_PROGRAMMES = 'programme.SET_PROGRAMMES'
export const GET_PROGRAMME = 'programme.GET_PROGRAMME'
export const SET_PROGRAMME = 'programme.SET_PROGRAMME'

export const getProgrammes = (params, callback) => ({
  type: GET_PROGRAMMES,
  params,
  callback,
})

export const setProgrammes = (data) => ({
  type: SET_PROGRAMMES,
  data
})

export const getProgramme = (programmeId, callback) => ({
  type: GET_PROGRAMME,
  programmeId,
  callback,
})

export const setProgramme = (data) => ({
  type: SET_PROGRAMME,
  data
})
